/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useForm } from "../../../provider/Form/FormProvider";
import MessageFormEditor from "../MessageForm/MessageFormEditor";
import React from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

export const MessageCenterMessageReplyForm = () => {
  const { handleSubmit, errors } = useForm();

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={"1rem"} sx={{ alignItems: "flex-end" }}>
        <MessageFormEditor />
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        ></Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Button fullWidth variant={"contained"} type={"submit"}>
            Weiter
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};
